import { render, staticRenderFns } from "./NoSessionData.vue?vue&type=template&id=72017157"
import script from "./NoSessionData.vue?vue&type=script&lang=js"
export * from "./NoSessionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports